export const truncateWithEllipsis = (text: string | undefined | null, maxLength: number): string => {
    if (!text) return '';
    const characters = Array.from(text);
    if (characters.length <= maxLength) return text;
    return `${characters.slice(0, maxLength).join('')}...`;
};
